/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChat_item">;
    readonly " $refType": "PdpRespDealerChatLoader_item";
};
export type PdpRespDealerChatLoader_item$data = PdpRespDealerChatLoader_item;
export type PdpRespDealerChatLoader_item$key = {
    readonly " $data"?: PdpRespDealerChatLoader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLoader_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerChatLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isPdpDealerChatTest",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isPdpDealerChatTest",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChat_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'd26244256ee600ad5756b7e916c47840';
export default node;
